// extracted by mini-css-extract-plugin
export default {"tag":"fDLXe","light":"GsnaK","box":"_Q3Oo","small":"Nkkiu","middle":"k98rF","dark":"q3XgG"};